import React, { Component, useState } from "react";

import { Button, ButtonGroup } from "react-bootstrap";
import { InputGroup } from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";

import "@app/css/datepicker_common.css";

class SystemMessageSearchConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: null,
            endDate: null,
        };
    }
    componentDidMount() {
        this.initDate();
    }

    initDate = () => {
        this.setSearchPeriod("months", 1);
    };

    onDateChange(isStartDate, date) {
        var monthDiff = isStartDate ? moment(this.state.endDate).diff(moment(date), "months", true) : moment(date).diff(moment(this.state.startDate), "months", true);

        var startDate = isStartDate ? date : this.state.startDate;
        var endDate = isStartDate ? this.state.endDate : date;
        if (monthDiff > 6) {
            if (isStartDate) {
                endDate = moment(date).add(6, "months").toDate();
            } else {
                startDate = moment(date).subtract(6, "months").toDate();
            }
            this.props.toast("검색 기간을 최대 6개월로 설정합니다.", { type: this.props.toast.TYPE.INFO });
        }
        this.setState({ startDate: startDate, endDate: endDate });
    }

    setSearchPeriod = (type, diff) => {
        var startDate = moment();
        var endDate = moment();

        startDate = startDate.subtract(diff, type);

        this.setState({ startDate: startDate.toDate(), endDate: endDate.toDate() }, () => this.onSearch());
    };

    onSearch = () => {
        if (this.props.isGridReady) {
            this.props.onSearchHandler(moment(this.state.startDate).format("YYYY-MM-DD"), moment(this.state.endDate).add(1, "days").format("YYYY-MM-DD"));
        }
    };

    render() {
        return (
            <div className="row">
                <div className="col">
                    <div className="card border-top border-3 border-top-secondary">
                        <div className="card-body" style={{}}>
                            <div className="row">
                                <div className="col-7">
                                    <InputGroup className="search-system-message">
                                        <InputGroup.Prepend>
                                            <InputGroup.Text style={{ width: "80px", justifyContent: "center" }}>조회 기간</InputGroup.Text>
                                        </InputGroup.Prepend>

                                        <InputGroup.Append className="input-group-append ">
                                            <DatePicker
                                                selected={this.state.startDate}
                                                onChange={(date) => this.onDateChange(true, date)}
                                                selectsStart
                                                startDate={this.state.startDate}
                                                endDate={this.state.endDate}
                                                maxDate={this.state.endDate}
                                                dateFormat="yy/MM/dd"
                                                customInput={<input type="text" className="form-control input-group-append" />}
                                            />
                                        </InputGroup.Append>
                                        <InputGroup.Append className="input-group-append" style={{ marginLeft: "-2px" }}>
                                            <InputGroup.Text>~</InputGroup.Text>
                                        </InputGroup.Append>
                                        <InputGroup.Append className="input-group-append">
                                            <DatePicker
                                                selected={this.state.endDate}
                                                onChange={(date) => this.onDateChange(false, date)}
                                                selectsEnd
                                                startDate={this.state.startDate}
                                                endDate={this.state.endDate}
                                                minDate={this.state.startDate}
                                                dateFormat="yy/MM/dd"
                                                customInput={<input type="text" className="form-control input-group-append" />}
                                            />
                                        </InputGroup.Append>
                                        <Button
                                            className="btn btn-dark input-group-append"
                                            style={{ borderRadius: "0px", paddingTop: "14px" }}
                                            onClick={() => this.initDate()}
                                            data-toggle="tooltip"
                                            title="조회 기간 초기화"
                                        >
                                            <i className="fas fa-times"></i>
                                        </Button>

                                        <Button className="btn btn-primary input-group-append" onClick={() => this.onSearch()}>
                                            조 회
                                        </Button>
                                    </InputGroup>
                                </div>
                                <div className="col-5">
                                    <InputGroup className="">
                                        <InputGroup.Prepend>
                                            <InputGroup.Text style={{ width: "80px", justifyContent: "center" }}>최근 기간</InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <ButtonGroup className="mr-2">
                                            <Button className="btn btn-outline-success" style={{ zIndex: 0, width: "70px" }} onClick={() => this.setSearchPeriod("days", 7)}>
                                                1주
                                            </Button>
                                            <Button className="btn btn-outline-success" style={{ zIndex: 0, width: "70px" }} onClick={() => this.setSearchPeriod("months", 1)}>
                                                1개월
                                            </Button>
                                            <Button className="btn btn-outline-success" style={{ zIndex: 0, width: "70px" }} onClick={() => this.setSearchPeriod("months", 3)}>
                                                3개월
                                            </Button>
                                            <Button className="btn btn-outline-success" style={{ zIndex: 0, width: "70px" }} onClick={() => this.setSearchPeriod("months", 6)}>
                                                6개월
                                            </Button>
                                        </ButtonGroup>
                                    </InputGroup>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SystemMessageSearchConfig;
